import Noty from 'noty'

let alerts = {
    methods: {
        alert (msg, type, timeout = 5000) {
            new Noty({
                text: msg,
                theme: 'metroui',
                timeout: timeout,
                type: type
            }).show()
        }
    }
}

export default alerts



// WEBPACK FOOTER //
// ./src/mixins/alerts.js